import { render, staticRenderFns } from "./section-team.vue?vue&type=template&id=4f2ec4ee&scoped=true"
import script from "./section-team.vue?vue&type=script&lang=js"
export * from "./section-team.vue?vue&type=script&lang=js"
import style0 from "./section-team.vue?vue&type=style&index=0&id=4f2ec4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ec4ee",
  null
  
)

export default component.exports